import React from "react";
import { Link, useHistory } from "react-router-dom";
import DataTable from "../core/ui/data-table";
import { Button } from 'reactstrap';

export default function AdminUserRoles() {
  const history = useHistory();

  const table_columns = [
    { header: "Role Name", key: "name" },
    { header: "Description", key: "description" },
  ];

  const table_actions = (role_code) => (
    <ul id="action-menu" className="action-menu">
      <Link to={"/admin-user-role-form#role_id=" + role_code.id}>
        {" "}
        <i className="bi bi-pencil" /> Edit
      </Link>
    </ul>
  );

  function onClickAdmin(ev) {
    ev.stopPropagation();
    history.push("/admin");
  }

  function onClickNew(ev) {
    ev.stopPropagation();
    history.push("/admin-user-role-form");
  }

  return (
    <div className="page admin-page">
      <div className="list-header sticky-page-header">
        <button className="new-button" onClick={onClickAdmin}>
          <i className="bi bi-chevron-left"></i> Admin
        </button>
        <h1>User Roles</h1>
        <i className="spacer" />
        <Button className='new-button' onClick={onClickNew}>New Role</Button>
      </div>
      <div className="roles-main margin-top-1">
        <DataTable
          query="admin/role_list"
          cols={table_columns}
          actions={table_actions}
          empty="No User Roles Found"
        />
      </div>
    </div>
  );
}
